import { useRequiredContext } from "@redotech/react-util/context";
import ShieldAlertIcon from "@redotech/redo-icons/shield-zap.svg";
import ShieldAlertFilledIcon from "@redotech/redo-icons/shield-zap_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { ReturnsAndClaimsPermissions } from "@redotech/redo-model/permissions";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useMatch } from "react-router-dom";
import { useZipCodeFraudFeatureFlag } from "../../../../return/fraud/use-zip-code-fraud-feature-flag";

export const FraudItem = memo(function FraudItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  const hasPermissionToViewItem = useHasPermission(
    ReturnsAndClaimsPermissions.VIEW_RETURN,
  );
  const { enabled: zipCodeFraudEnabled } = useZipCodeFraudFeatureFlag();

  const anyChildSelected = useMatch(`${routes.fraudHref}/*`);

  if (!hasPermissionToViewItem || !zipCodeFraudEnabled) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.fraudHref }}
      anyChildSelected={!!anyChildSelected}
      beta
      FilledIcon={ShieldAlertFilledIcon}
      friendlyName="Fraud"
      id="fraud"
      UnfilledIcon={ShieldAlertIcon}
    />
  );
});
